import { db } from "../../../config/firebaseconfig";
import getById from "./getById";
import tallyLicenses from "./tallyLicenses";

export default function toggleStudentLicense (userId, users, licenseId) {
  const user = getById(users, userId)
  // if there is no licenses property, create it and set license true
  if (!user.licenses) {
    const updateStudent = db.collection('students').doc(userId).update({
      licenses: {[licenseId]: true}
    })
    const updateLicense = db.collection('accountLicenses').doc(licenseId).get()
      .then(doc => {
        if (doc.exists) {
          const license = doc.data()
          const userPath = `licensedUsers.${userId}`
          const updateData = {
            licensedCount: tallyLicenses(license) + 1,
            [userPath]: true,
          }
          return db.collection('accountLicenses').doc(licenseId).update(updateData)
        } else throw Error('License does not exist')
      })
    return Promise.all([updateStudent, updateLicense])
    //otherwise, toggle the license

  } else {

    const path = `licenses.${licenseId}`
    const updateLicense = db.collection('accountLicenses').doc(licenseId).get()
      .then(doc => {
        if (doc.exists) {
          const license = doc.data()
          const userPath = `licensedUsers.${userId}`
          const status = !user.licenses[licenseId]
          const adjustment = status ? 1 : -1
          const updateData = {
            licensedCount: tallyLicenses(license) + adjustment,
            [userPath]: status,
          }
          return db.collection('accountLicenses').doc(licenseId).update(updateData)
        } else throw Error('License does not exist')
      })

    const updateStudent = db.collection('students').doc(userId).update({
      [path]: !user.licenses[licenseId]
    })

    return Promise.all([updateStudent, updateLicense])
    
  }
}


// WEBPACK FOOTER //
// ./src/helpers/users/licenses/toggleStudentLicense.js